export const countryCodes = {
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BA: "Bosnia and Herzegovina",
  BN: "Brunei",
  BO: "Bolivia",
  JP: "Japan",
  BI: "Burundi",
  BJ: "Benin",
  BT: "Bhutan",
  JM: "Jamaica",
  BW: "Botswana",
  BR: "Brazil",
  BS: "The Bahamas",
  BY: "Belarus",
  BZ: "Belize",
  RU: "Russia",
  RW: "Rwanda",
  RS: "Republic of Serbia",
  LT: "Lithuania",
  LU: "Luxembourg",
  LR: "Liberia",
  RO: "Romania",
  GW: "Guinea Bissau",
  GT: "Guatemala",
  GR: "Greece",
  GQ: "Equatorial Guinea",
  GY: "Guyana",
  GE: "Georgia",
  GB: "United Kingdom",
  GA: "Gabon",
  GN: "Guinea",
  GM: "Gambia",
  GL: "Greenland",
  KW: "Kuwait",
  GH: "Ghana",
  OM: "Oman",
  _3: "Somaliland",
  _2: "Western Sahara",
  _1: "Kosovo",
  _0: "Northern Cyprus",
  JO: "Jordan",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  HN: "Honduras",
  PR: "Puerto Rico",
  PS: "West Bank",
  PT: "Portugal",
  PY: "Paraguay",
  PA: "Panama",
  PG: "Papua New Guinea",
  PE: "Peru",
  PK: "Pakistan",
  PH: "Philippines",
  PL: "Poland",
  ZM: "Zambia",
  EE: "Estonia",
  EG: "Egypt",
  ZA: "South Africa",
  EC: "Ecuador",
  AL: "Albania",
  AO: "Angola",
  KZ: "Kazakhstan",
  ET: "Ethiopia",
  ZW: "Zimbabwe",
  ES: "Spain",
  ER: "Eritrea",
  ME: "Montenegro",
  MD: "Moldova",
  MG: "Madagascar",
  MA: "Morocco",
  UZ: "Uzbekistan",
  MM: "Myanmar",
  ML: "Mali",
  MN: "Mongolia",
  MK: "Macedonia",
  MW: "Malawi",
  MR: "Mauritania",
  UG: "Uganda",
  MY: "Malaysia",
  MX: "Mexico",
  VU: "Vanuatu",
  FR: "France",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NG: "Nigeria",
  NZ: "New Zealand",
  NP: "Nepal",
  CI: "Ivory Coast",
  CH: "Switzerland",
  CO: "Colombia",
  CN: "China",
  CM: "Cameroon",
  CL: "Chile",
  CA: "Canada",
  CG: "Republic of the Congo",
  CF: "Central African Republic",
  CD: "Democratic Republic of the Congo",
  CZ: "Czech Republic",
  CY: "Cyprus",
  CR: "Costa Rica",
  CU: "Cuba",
  SZ: "Swaziland",
  SY: "Syria",
  KG: "Kyrgyzstan",
  KE: "Kenya",
  SS: "South Sudan",
  SR: "Suriname",
  KH: "Cambodia",
  SV: "El Salvador",
  SK: "Slovakia",
  KR: "South Korea",
  SI: "Slovenia",
  KP: "North Korea",
  SO: "Somalia",
  SN: "Senegal",
  SL: "Sierra Leone",
  SB: "Solomon Islands",
  SA: "Saudi Arabia",
  SE: "Sweden",
  SD: "Sudan",
  DO: "Dominican Republic",
  DJ: "Djibouti",
  DK: "Denmark",
  DE: "Germany",
  YE: "Yemen",
  AT: "Austria",
  DZ: "Algeria",
  US: "United States of America",
  LV: "Latvia",
  UY: "Uruguay",
  LB: "Lebanon",
  LA: "Laos",
  TW: "Taiwan",
  TT: "Trinidad and Tobago",
  TR: "Turkey",
  LK: "Sri Lanka",
  TN: "Tunisia",
  TL: "East Timor",
  TM: "Turkmenistan",
  TJ: "Tajikistan",
  LS: "Lesotho",
  TH: "Thailand",
  TF: "French Southern and Antarctic Lands",
  TG: "Togo",
  TD: "Chad",
  LY: "Libya",
  AE: "United Arab Emirates",
  VE: "Venezuela",
  AF: "Afghanistan",
  IQ: "Iraq",
  IS: "Iceland",
  IR: "Iran",
  AM: "Armenia",
  IT: "Italy",
  VN: "Vietnam",
  AR: "Argentina",
  AU: "Australia",
  IL: "Israel",
  IN: "India",
  TZ: "Tanzania",
  AZ: "Azerbaijan",
  IE: "Ireland",
  ID: "Indonesia",
  UA: "Ukraine",
  QA: "Qatar",
  MZ: "Mozambique",
  GD: "Grenada",
  JE: "Jersey",
  SG: "Singapore",
  HK: "Hong Kong",
  AD: "Andorra",
  AG: "Antigua and Barbuda",
  BH: "Bahrain",
  BB: "Barbados",
  CV: "Cape Verde",
  KM: "Comoros",
  DM: "Dominica",
  LI: "Liechtenstein",
  MV: "Maldives",
  MT: "Malta",
  MH: "Marshall Islands",
  FM: "Micronesia",
  MC: "Monaco",
  NR: "Nauru",
  PW: "Palau",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SC: "Seychelles",
  TO: "Tonga",
  TV: "Tuvalu",
  VA: "Vatican City"
};
